<script>
	import thumb_EnSqxtCIZ6o from '$lib/Components/Youtube/images/EnSqxtCIZ6o.jpg?w=610';
	import thumb_HNJDOfz1G48 from '$lib/Components/Youtube/images/HNJDOfz1G48.jpg?w=610';
	import thumb_WPNWItsrqMU from '$lib/Components/Youtube/images/WPNWItsrqMU.jpg?w=610';
	import thumb_Y3E8dnh_bow from '$lib/Components/Youtube/images/Y3E8dnh-bow.jpg?w=610';

	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import MeasureSupport from '$lib/PageSections/Forms/MeasureSupport/MeasureSupport.svelte';
</script>

<Section>
	<h2>How to Measure Your Windows with our Laser Measure Tool</h2>
	<p>
		This page will help you measure your windows, no matter the method. Whether
		you are measuring with our Laser Measure Tool or your own Measuring Tape, we
		have instructions to help. We also have tips if your measurements aren’t
		working and a way to access Measure by Indow (the measure portal for Indow)
		if you’ve been locked out.
	</p>
	<p>
		Read our <a href="/guides/how-to-measure-with-a-laser"
			>laser measure guide</a
		>, request your
		<a href="/self-measure-instructions#measure-support-form"
			>Measure By Indow portal link</a
		>, or
		<a href="/measure-support">schedule a Measure Support call</a>.
	</p>
	<Youtube
		posterImageSrc={thumb_Y3E8dnh_bow}
		videoId="Y3E8dnh-bow"
		posterloading="eager"
	/>
</Section>

<Section>
	<h2>How to Measure Your Windows with a Measuring Tape</h2>
	<p>
		Read our <a href="/guides/how-to-measure-with-tape">tape measure guide</a>,
		download the
		<a href="/guides/tape-measurement-form">tape measure form</a>, request your
		<a href="/self-measure-instructions#measure-support-form"
			>Measure By Indow portal link</a
		>, or <a href="/measure-support">schedule a Measure Support call</a>.
	</p>

	<Youtube posterImageSrc={thumb_HNJDOfz1G48} videoId="HNJDOfz1G48" />
</Section>

<Section>
	<h2>How to Measure Your Windows for Mullions</h2>
	<p>
		Watch the video below for instructions on how to measure your windows if you
		plan on using mullions for your inserts. Make sure your <a
			href="/guides/laser-measurement-form">measurement form</a
		>
		is handy and read our
		<a href="/guides/how-to-measure-for-mullions">mullion measurement guide</a>.
	</p>

	<Youtube posterImageSrc={thumb_EnSqxtCIZ6o} videoId="EnSqxtCIZ6o" />
</Section>

<Section>
	<h2>Helpful Tips</h2>
	<p>
		Frame step: We have a blog & video <a
			href="/resources/blog/what-is-a-frame-step">all about frame steps</a
		>!
	</p>
	<Youtube posterImageSrc={thumb_WPNWItsrqMU} videoId="WPNWItsrqMU" />
	<p>
		Unfamiliar terms? Read our <a
			href="/resources/faq/interior-storm-window-inserts-glossary"
			>glossary of terms</a
		>.
	</p>
	<p>
		Read more about our <a href="/resources/blog/why-we-laser-measure-windows"
			>How to Measure Your Windows with our Laser Measure Tool</a
		>.
	</p>
	<p>
		Watch our video tips on using the <a href="https://youtu.be/IXPkJBO_cWE"
			>Laser Extension Tool</a
		>.
	</p>
	<p>
		Want details on cleaning your insert? Read our <a href="/about-indow/care"
			>care guide</a
		>.
	</p>
	<p>
		Especially tall and narrow windows are difficult to measure. If you are
		having trouble completing your measurements or getting them to validate,
		please let us know so we can help. Make an appointment below.
	</p>
</Section>

<Section>
	<h2>Tape Measure Troubleshooting Guide</h2>
	<h3>My measurements weren’t accepted. What now?</h3>
	<ol
		class="
    marker-number marker-circle list-none
    [&_p]:w-full [&_p]:text-left
  "
	>
		<li>
			<p>
				Use a metal tape measure. Fabric tape measures can stretch and give
				inaccurate measurements.
			</p>
		</li>
		<li>
			<p>Use the same tape measure to record all measurements.</p>
		</li>
		<li>
			<p>Keep the tape measure taut across all measurements.</p>
		</li>
		<li>
			<p>
				Compare the measurements entered into your Measure by Indow portal to
				those written on the Measure Form to verify there are no errors.
			</p>
		</li>
		<li>
			<p>
				Review your width (A & B) and height (C & D) measurements. Typically,
				the left and right heights (C & D) are within ½” of each other even if
				the window frame is out of square. It is unusual to see a left height of
				35” and a right height of 36” on the same window. The same is true for
				the top and bottom widths (A & B).
			</p>
		</li>
		<li>
			<p>Make sure the “Tape Measure” checkbox is checked.</p>
		</li>
	</ol>
	<p>
		Once you’ve taken these steps, if the measurements still aren’t accepted,
		schedule a <a href="/measure-support">Measure Support call</a>.
	</p>
</Section>

<Section id="measure-support-form">
	<h2>Request Your Measure By Indow Portal</h2>
	<p>
		You need to provide your measurement details through Measure by Indow. A
		link to the self measure form should have been provided in the first email
		after your order was confirmed. If you can’t find it, don’t panic! Let us
		know and we can help with your measurements, self measure kits (laser
		measure kit), consultation to measurement, or anything you need.
	</p>
	<div id="measure-support-form">
		<MeasureSupport />
	</div>
</Section>
